module.exports = __webpack_public_path__ + "img/fin_06_种子储藏室.acbb5f07.jpg";